export function TermsPage() {
  return (
    <article>
      <h1>Terms</h1>

      <p>
        These are the terms for Guess My Time, a free closest-guess sweepstake tool run by{' '}
        <strong>Webhooks Ltd</strong> (UK company number 16791194). Using the site means you accept them.
      </p>

      <h2>Definitions</h2>
      <ul style={{ paddingLeft: 18 }}>
        <li><strong>Organiser</strong> — a signed-in user who creates a sweepstake.</li>
        <li>
          <strong>Guesser</strong> — anyone who submits a guess on a public sweepstake page. Sign-in not required.
        </li>
        <li>
          <strong>Sweepstake</strong> — a single closest-guess contest with a public page at <code>/s/{'{slug}'}</code>.
        </li>
        <li>
          <strong>Donation page</strong> — the external HTTPS URL the organiser nominates (typically JustGiving,
          GoFundMe or similar). Guess My Time never touches the money.
        </li>
      </ul>

      <h2>What you can do</h2>
      <ul style={{ paddingLeft: 18 }}>
        <li>Create sweepstakes to support genuine fundraising events.</li>
        <li>Share the public link freely with friends, family, colleagues.</li>
      </ul>

      <h2>What you can't do</h2>
      <ul style={{ paddingLeft: 18 }}>
        <li>
          Use Guess My Time as a gambling or paid-prize-draw product. Entering a guess <em>must</em> be free —
          see "Why this isn't a lottery" below.
        </li>
        <li>Abuse the tool: spam, scraping, automated guess submission, attempts to circumvent rate limits.</li>
        <li>Submit content that's unlawful, defamatory, or impersonates someone else.</li>
        <li>
          As an organiser, use the tool for anything other than a real fundraising event for a genuine cause.
        </li>
      </ul>

      <h2>Why this isn't a lottery</h2>
      <p>
        Under the Gambling Act 2005 (s.14), a lottery requires (broadly) <em>payment for entry</em>. Guess My
        Time is designed so that entry is always free: the guess form has no payment step, and the donation
        happens off-site on a fundraising page the organiser has chosen.
      </p>
      <p>
        For this to remain true, organisers must keep the two strictly separate. Don't tell guessers that they
        need to donate to be eligible, don't gate the winner announcement on donation status, and don't promise
        anything beyond inclusion on the leaderboard in exchange for a guess. If you do, the arrangement may
        cross the line into a regulated lottery and that's on you — see "Liability" below.
      </p>

      <h2>Accounts and termination</h2>
      <p>
        Organisers can delete their account (and cascade-delete every sweepstake and guess they created) from
        their dashboard at any time. We can suspend or remove a sweepstake or account if we reasonably believe
        it breaches these terms — for example, if it's being used for harassment, fraud, or to disguise paid
        gambling. We'll explain the reason and, where possible, give you a chance to fix it first.
      </p>

      <h2>Liability</h2>
      <p>
        Guess My Time is free and provided "as is". We don't guarantee uptime; if the service is unavailable on
        the day of an event the organiser is responsible for picking a winner by other means (we suggest a
        screenshot of the leaderboard taken in advance).
      </p>
      <p>
        Nothing in these terms limits or excludes any liability that cannot lawfully be limited or excluded —
        in particular, liability for death or personal injury caused by negligence, for fraud or fraudulent
        misrepresentation, or your statutory rights as a consumer under the Consumer Rights Act 2015.
      </p>
      <p>
        Subject to that, and to the maximum extent permitted by law, Webhooks Ltd is not liable for:
      </p>
      <ul style={{ paddingLeft: 18 }}>
        <li>indirect, incidental or consequential loss;</li>
        <li>loss of profits, anticipated savings, goodwill or business opportunity;</li>
        <li>anything that happens on a third-party fundraising page linked from a sweepstake;</li>
        <li>conduct of an organiser or guesser that breaches these terms.</li>
      </ul>

      <h2>Privacy</h2>
      <p>
        How we handle your data is described in our <a href="/privacy">privacy notice</a>. Webhooks Ltd is the
        data controller for everything you submit via Guess My Time.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms from time to time. If we make material changes we'll email signed-in
        organisers at least 14 days before the new version takes effect, and you can stop using Guess My Time
        if you don't agree. Changes never apply retroactively to a sweepstake that has already been resolved.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by the laws of England and Wales, and any dispute will be subject to the
        exclusive jurisdiction of the courts of England and Wales.
      </p>

      <h2>Contact</h2>
      <p>
        <a href="mailto:hello@guessmytime.com">hello@guessmytime.com</a>.
      </p>

      <p className="muted" style={{ fontSize: 14, marginTop: 24 }}>
        Last updated: 2026-05-13.
      </p>
    </article>
  );
}
